import React, {useState, useEffect} from "react"
import TestPaper from "./TestPaper"
import TimeAndTemp from "./TimeAndTemp"
import CodeInput from "./CodeInput"
import FormulaReward from "./FormulaReward"

function Science(props) {
    const [mounted, setMounted] = useState(false)
    const [puzzleCompleted, setPuzzleCompleted] = useState(false)
    const [runTime, setRunTime] = useState(false)
    const [temperatureStats] = useState({
        startingTemp: 30,
        finalTemp: 80,
        visualInterval: (80 - 30)/4,
        dotRows: [".dotRowOne", ".dotRowTwo", ".dotRowThree", ".dotRowFour"]
    })
    const [currentTemp, setCurrentTemp] = useState(temperatureStats.startingTemp)
    const [timeStats] = useState({
        finalTime: 12,
        handInterval: 360/60,
    })
    const [currentSeconds, setCurrentSeconds] = useState(0)
    const [rotateDegree, setRotateDegree] = useState(0)
    const [,setClock] = useState("")
    const barIds = ["barOne", "barTwo", "barThree", "barFour", "barFive"]
    
    function runAnalysis() {
        setRunTime(false)
        setCurrentTemp(temperatureStats.startingTemp)
        setCurrentSeconds(0)
        setRotateDegree(0)
        let tempDots = Array.from(document.querySelectorAll(".temperatureDot"))
        tempDots.map(dot => { return dot.style.transition = "opacity 0.1s" })
        
        temperatureStats.dotRows.map(value => {
            const tempDotsRow = Array.from(document.querySelectorAll(value))
            return tempDotsRow.map(dot => { return dot.style.opacity = "0" })
        })
        
        const tempDotsSpecial = Array.from(document.querySelectorAll(".specialDot"))
        tempDotsSpecial.map(dot => { return dot.classList.remove("endColor") })
        
        document.getElementById("verticalResult").style.transition = "all 0.1s"
        document.getElementById("verticalResult").style.minHeight = "0"
              
        const horizontalBars = Array.from(document.querySelectorAll(".horizontalBar"))
        horizontalBars.map(bar => { return bar.style.transition = "all 0.1s"})

        barIds.map(value => { return document.getElementById(value).style.minWidth = "0"})

        document.getElementById("secondHandRotate").style.transform = ("rotate(0deg)")
        setTimeout(() => increaseTemperature(), 125)
    }

    function increaseTemperature() {
        if (currentTemp === temperatureStats.startingTemp) {
            let transitionUpdate = Array.from(document.querySelectorAll(".temperatureDot"))
            transitionUpdate.map(dot => { return dot.style.transition = "opacity 5s"})
        }
        
        setCurrentTemp(prevTemp => prevTemp + 1)
    }
    
    useEffect(() => {
        if (mounted) {
            let selectedRow
            const base = temperatureStats.startingTemp
            if (currentTemp >= (base + (temperatureStats.visualInterval*3))) {
                selectedRow = ".dotRowOne" 
            } else if (currentTemp >= (base + (temperatureStats.visualInterval*2))) {
                selectedRow = ".dotRowTwo"    
            } else if (currentTemp >= (base + temperatureStats.visualInterval)) {
                selectedRow = ".dotRowThree"  
            } else {
                selectedRow = ".dotRowFour"  
            }

            let row = Array.from(document.querySelectorAll(selectedRow))
            row.map(dot => { return dot.style.opacity = "1"})

            if (currentTemp >= temperatureStats.finalTemp) {
                const specials = Array.from(document.querySelectorAll(".specialDot"))
                specials.map(dot => { return dot.classList.add("endColor") })
                setRunTime(true)
                document.getElementById("verticalResult").style.transition = "all 14s"
                document.getElementById("verticalResult").style.minHeight = "80%"
                const bars = Array.from(document.querySelectorAll(".horizontalBar"))
                bars.map(bar => { return bar.style.transition = "all 4s" })
            } else {
                setTimeout(() => increaseTemperature(), 125)
            }
        } else {
            setMounted(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[currentTemp, temperatureStats.finalTemp, temperatureStats.startingTemp, temperatureStats.visualInterval])
    
    function increaseTime() {
        setCurrentSeconds(prevSecs => prevSecs + 1)
    }
    
    useEffect(() => {
        if (runTime) {
            setRotateDegree(timeStats.handInterval*currentSeconds)
            if (currentSeconds >= 2) {
                document.getElementById("barOne").style.minWidth = "100px"
                document.getElementById("barTwo").style.minWidth = "100px"
            }

            if (currentSeconds >= 4) {
                document.getElementById("barThree").style.minWidth = "100px"
            }

            if (currentSeconds >= 6) {
                document.getElementById("barFour").style.minWidth = "100px"
            }

            if (currentSeconds >= 8) {
                document.getElementById("barFive").style.minWidth = "100px"
            }
        }
        
        if (currentSeconds >= timeStats.finalTime) { 
            setRunTime(false)
        }
        
    }, [currentSeconds, timeStats.finalTime, timeStats.handInterval, runTime])
    
    useEffect(() => {
        if (runTime) {
            const rotation = "rotate(" + rotateDegree + "deg)"
            document.getElementById("secondHandRotate").style.transform = rotation 
        } 
    }, [rotateDegree, runTime])
    
    useEffect(() => {
        runTime ? setClock(() => setInterval(() => increaseTime(), 1000)) : setClock(prevClock => clearInterval(prevClock))
    },[runTime])

    function completed() {
        setPuzzleCompleted(true)
        props.callBackKeypad(true)
    }
    
    const formulaHeader = (puzzleCompleted ? <h1 className="formulaTitle">B2A4SrCaH2K2</h1> : <button className="standardButton animateAnalysisButton" onClick={runAnalysis}>Run Analysis</button>)
    
    const formulaFooter = (puzzleCompleted ? <FormulaReward /> : <CodeInput callBack={completed}/>)
    
    return (
        <div className="phaseFourNormalWrapper">
            <h3 className="phaseIntro">Jack may be a crook but when he wants to talk his leads have always been solid. We need to identify this red substance. Good thing you paid attention in science class...</h3>

            <div className="imageTextWrapper">
                {formulaHeader}
            </div>

            <div className="imageTextWrapper analysisFullWrapper">                
                <div className="analysisAnimationWrapper">
                    <TestPaper />
                    <TimeAndTemp currentSeconds={currentSeconds} currentTemp={currentTemp}/>
                </div>

                <div className="formulaFooterBar">
                    {formulaFooter}
                </div>
            </div>
        </div>
    )
}

export default Science


    